import React from 'react';
import { useIntl } from 'react-intl-next';
import { ProformaIntlProvider } from '@atlassian/proforma-utils/intl-provider';
import commonCoreLazyMessages from '../i18n/lazy';
export const PackageIntlProvider = ({
  children,
  locale
}) => /*#__PURE__*/React.createElement(ProformaIntlProvider, {
  locale: locale,
  messages: commonCoreLazyMessages
}, children);

/**
 * This is a simple HoC wrapper for PackageIntlProvider.
 */
export const withPackageIntlProvider = WrappedComponent => props => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(PackageIntlProvider, {
    locale: intl.locale
  }, /*#__PURE__*/React.createElement(WrappedComponent, props));
};